export const getTotals = (totalsOfAdmin, term) => {
 
    if (term === "/admin/products") {
      const total = totalsOfAdmin?.totalUnquotedProducts;
      return total;
    } else if (term === "/admin/orders") {
      const total = totalsOfAdmin?.totalProcessingOrders;
      return total;
    } 
    else if (term === "/customer/orders/dispute-list") {
      console.log("totals of", totalsOfAdmin)
      const total = totalsOfAdmin?.totalReplyDisputes;
      return total;
    }
    else if (term === "/customer/orders/returned-to-overseas-warehouse") {

   
      const total = totalsOfAdmin?.totalReplyReturnToOverseas;
     
      return total;
    }
    else if (term === "/admin/orders/dispute-list") {
      const total = totalsOfAdmin?.totalReplyDisputes;
      return total;
    } else if (term === "/admin/payments") {
      const total = totalsOfAdmin?.totalPendingDepositsPayments;
      return total;
    } else {
      const total = totalsOfAdmin?.totalActiveUsers;
      return total;
    }
  };